import type { ReactElement } from "react";
import { useMemo } from "react";

import { translate } from "app/filters/i18nFilter";
import type { IRadioSelectItem } from "app/pages/sales-intelligence/common-components/form-fields";
import { HorizontalRadioSelect } from "app/pages/sales-intelligence/common-components/form-fields";
import type { InclusionOption } from "app/pages/sales-intelligence/types/commonMaps";
import { binaryInclusionOptions } from "app/pages/sales-intelligence/types/commonMaps";

interface IProps {
    value: InclusionOption;
    onChange: (value: InclusionOption) => void;
}

const IabCategoriesInclusion = ({ value, onChange }: IProps): ReactElement => {
    const allOptions = useMemo((): IRadioSelectItem[] => {
        return binaryInclusionOptions.map(
            (inclusionOption: InclusionOption): IRadioSelectItem => ({
                id: inclusionOption,
                text: translate(`si.common.inclusions.${inclusionOption}`),
            }),
        );
    }, []);

    return (
        <div>
            <HorizontalRadioSelect
                size="sm"
                items={allOptions}
                selected={value}
                onSelect={onChange}
            />
        </div>
    );
};

export default IabCategoriesInclusion;
